<template>
  <div>
    <button
      class="Button Button--primary outbound signup-modal"
      @click.prevent="openRedirectModal"
    >
      Visit Careers Site
    </button>
    <base-modal
      v-model="showRedirectModal"
      @base-modal:closed="handleModalState"
    >
      <template #modal-body>
        <redirect-form
          :redirect-url="url"
          lang-key="companies"
          import-comment="Companies Redirect Modal"
        />
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '@/components/modal/base-modal.vue';
import RedirectForm from '@/components/authentication/register-touch-points/redirect-form.vue';

export default {
  components: { RedirectForm, BaseModal },
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showRedirectModal: false,
    };
  },
  methods: {
    openRedirectModal() {
      this.showRedirectModal = true;
    },
    handleModalState() {
      this.showRedirectModal = false;
      window.location.href = this.url;
    },
  },
};
</script>
